<template>
  <div id="app">
    <!-- 头部 -->
    <Header/>
    <!-- 路由出口 -->
    <router-view/>
    <!-- 尾部1 -->
    <Footer1/>
    <!-- 尾部2 -->
    <Footer2/>
    <!-- 菜单模态框 -->
    <Model/>
  </div>
</template>


<script>
import Header from "@/components/Header.vue";
import Footer1 from "@/components/Footer1.vue";
import Footer2 from "@/components/Footer2.vue";
import Model from "@/components/Model.vue";
export default {
  name: "app",

  // 注册组件
  components: {
    Header,
    Footer1,
    Footer2,
    Model
  },

  watch: {
    $route: {
      handler: function(val, oldVal){
        if(val.name!=oldVal.name){ // 当路由发生改变
          this.$Bus.$emit('show',false); // 传值给菜单model组件
        }
        if(val.name=='classify'||val.name=='details'||val.name=='product_search'){
          this.$Bus.$emit('product',true);
        }else{
          this.$Bus.$emit('product',false);
        }

        if(val.name=='problemdetails'){
          this.$Bus.$emit('problem',true);
        }else{
          this.$Bus.$emit('problem',false);
        }
        
        if(val.name=='newsdetails'){
          this.$Bus.$emit('news',true);
        }else{
          this.$Bus.$emit('news',false);
        }

      },
      // 深度观察监听
      deep: true
    }
  },

};
</script>



<style lang="less">
  * {
    margin: 0;
    padding: 0;
  }
  // 版心
  .type_area {
    width: 90%;
    margin: 0 auto;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
  }

  // 新闻详情页的视频
  .video-js .vjs-big-play-button{
     width:4rem !important;
     height:4rem !important;
     border-radius: 100% !important;
     position:absolute;
     top: 0;
     right: 0;
     bottom: 0;
     left: 0;
     margin: auto auto;
     display:flex;
     justify-content: center;
     align-items: center;
  }

  
  // 兼容产品详情页面后台返回的表格
  // 表格1/表格2
  table{
      width:100% !important;
      border-collapse: collapse !important; 
      tbody{
        width:100% !important;
        tr{
          width:100% !important;
          td{
            border:1px solid #ccc !important;
            width:auto !important;
          }
         
        }
      }
  }

</style>
